<app-base-layout>
  <div class="layout-body" *ngIf="content">
    <div [innerHTML]="content"></div>
  </div>
</app-base-layout>
